import DashboardGraphOrders from "@/components/ViewDashboard/DashboardGraphs/dashboardGraphOrders.component";
import DashboardGraphQuotes from "@/components/ViewDashboard/DashboardGraphs/dashboardGraphQuotes.component";
import { fetchDashboardCounts } from "@/models/socket/dashboard.model";
import { DashboardCountResponse } from "@/types";
import React, { useEffect, useState } from "react";

type ViewDashboardProps = {
  // TODO: add props here
};

const ViewDashboard: React.FC<ViewDashboardProps> = (props) => {
  const [dashboardCounts, setDashboardCounts] =
    useState<DashboardCountResponse>({
      orderData: {
        inProgress: 0,
        completed: 0,
        total: 0,
      },
      quoteData: {
        open: 0,
        accepted: 0,
        rejected: 0,
        total: 0,
      },
    });

  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    // fetchDashboardCounts
    async function fetchData() {
      setLoading(true);
      setError(null);

      const response = await fetchDashboardCounts();
      if (response.rStatus === "success") {
        setDashboardCounts(response.rData);
      } else {
        setError(response.rData);
      }
      setLoading(false);
    }

    fetchData();
  }, []);
  return loading ? (
    <div className="py-4">
      <div className="flex items-center justify-center">
        <div className="h-10 w-10 animate-spin rounded-full border-b-3 border-white"></div>
      </div>
      <div className="flex items-center justify-center">
        <h2 className="mt-2 text-xl text-white">Loading Dashboard...</h2>
      </div>
    </div>
  ) : error ? (
    <div className="text-center text-red-600">
      <p>Error: {error}</p>
    </div>
  ) : (
    <div className="m-auto max-w-7xl space-y-4 p-4">
      <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
        <DashboardGraphQuotes quotesCounts={dashboardCounts.quoteData} />
        <DashboardGraphOrders ordersCounts={dashboardCounts.orderData} />
      </div>
    </div>
  );
};

export default ViewDashboard;
